var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "course-item" },
    [
      !_vm.course.coming_soon || _vm.user.is_staff
        ? _c(
            "router-link",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: {
                    axId: "clicked_course_card_from_learning_path",
                    axType: "button",
                    axExtra: {
                      learning_path_id: _vm.learningPath.learning_path_id,
                      learning_path_name: _vm.learningPath.name,
                      course_id: _vm.course.course_id,
                      course_name: _vm.course.name
                    }
                  },
                  expression:
                    "{\n      axId: 'clicked_course_card_from_learning_path',\n      axType: 'button',\n      axExtra: {\n        learning_path_id: learningPath.learning_path_id,\n        learning_path_name: learningPath.name,\n        course_id: course.course_id,\n        course_name: course.name,\n      },\n    }",
                  arg: "click"
                }
              ],
              staticClass: "course clickable",
              attrs: {
                to: {
                  name: "explorations_topics",
                  params: { courseSlug: _vm.course.slug }
                }
              }
            },
            [
              _c("CourseItemContent", {
                attrs: { course: _vm.course, "course-number": _vm.courseNumber }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "course" },
            [
              _c("CourseItemContent", {
                attrs: { course: _vm.course, "course-number": _vm.courseNumber }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }